import { Tooltip } from "@material-ui/core"
import { ImageLoader } from "components/ImageLoader"
import { ModalContainer } from "components/ModalContainer"
import { Channel } from "definitions/Channel"
import { ListOptionsCompany } from "definitions/Company"
import { useNotification } from "hooks/notification"
import React, { useEffect, useState } from "react"
import { translate } from "translate/i18n"
import { getRequest } from "utils/request"
import { checkDocument } from "utils/strings"

type ModalChangeCurrentCompanyProps = {
  companyList: ListOptionsCompany[]
  changeCurrentCompany: (dto: { value: string | number }) => void
}

const companyContainerStyle = {
  cursor: "pointer",
  borderRadius: "5px",
  border: "1px solid",
  borderColor: "#ddd",
  boxShadow: "0 1px 3px rgba(0,0,0,.2)",
  transition: "border-color 0.3s, box-shadow 0.3s",
  minHeight: "90px",
}

const companyContainerHoverStyle = {
  ...companyContainerStyle,
  borderColor: "lightblue",
  boxShadow: "0 0 10px rgba(0, 123, 255, 0.7)",
}

const gridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "15px",
}

const listStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "15px",
}

export function ModalChangeCurrentCompany(
  props: ModalChangeCurrentCompanyProps
): JSX.Element {
  const { companyList, changeCurrentCompany } = props
  const [channels, setChannels] = useState<Channel[]>([])
  const [hoveredCompany, setHoveredCompany] = useState(-1)

  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [viewMode, setViewMode] = useState<"list" | "grid">("list")

  const openModal = () => setModalIsOpen(true)
  const closeModal = () => setModalIsOpen(false)

  const { selectedCompany } = useNotification()

  async function getData() {
    const channelsResponse = await getRequest<Channel[]>(`/channels`)
    if (channelsResponse.success) {
      setChannels(channelsResponse.data)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  useEffect(() => {
    console.log("currentCompany", selectedCompany)
  }, [selectedCompany])

  return (
    <>
      <div className="d-flex align-items-center p-1 mr-2">
        <div
          className="mr-3"
          style={{
            // opacity: 0.8,
            lineHeight: "10px",
          }}
        >
          <h2 className="m-0">{selectedCompany.label}</h2>
          {checkDocument(selectedCompany.document) !== "invalid" && (
            <p className="m-0">
              <strong className="mr-1" style={{}}>
                {checkDocument(selectedCompany.document).toUpperCase()}:
              </strong>
              {selectedCompany.document}
            </p>
          )}
        </div>
        <button
          className="btn d-flex align-items-center"
          style={{
            border: "2px solid rgba(100,100,100,0.2)",
            borderRadius: "10px",
          }}
          onClick={openModal}
        >
          <i className="mdi mdi-office-building mr-1" />
          Alterar Empresa
        </button>
      </div>

      {/* @ts-ignore */}
      <ModalContainer
        isOpen={modalIsOpen}
        closeModal={closeModal}
        Header={
          <div
            className="modal-header d-flex justify-content-between align-items-center p-0 w-100"
            style={{ position: "relative" }}
          >
            <h2 className="modal-title">{translate("chooseCompany")}</h2>
            <div
              className="btn-group ml-auto"
              style={{
                gap: "5px",
              }}
            >
              <button
                style={{
                  width: "20px",
                  height: "20px",
                  padding: 0,
                  margin: 0,
                }}
                className={`btn btn-sm ${
                  viewMode === "list"
                    ? "btn-secondary"
                    : "btn-outline-secondary"
                }`}
                onClick={() => setViewMode("list")}
              >
                <i className="mdi mdi-format-list-bulleted" />
              </button>
              <button
                style={{
                  width: "20px",
                  height: "20px",
                  padding: 0,
                  margin: 0,
                }}
                className={`btn btn-sm ${
                  viewMode === "grid"
                    ? "btn-secondary"
                    : "btn-outline-secondary"
                }`}
                onClick={() => setViewMode("grid")}
              >
                <i className="mdi mdi-grid" />
              </button>
            </div>
          </div>
        }
      >
        <div style={viewMode === "grid" ? gridStyle : listStyle}>
          {companyList.map((company) => (
            <div
              key={company.value}
              className={`company-container mb-0`}
              style={
                hoveredCompany === company.value
                  ? companyContainerHoverStyle
                  : companyContainerStyle
              }
              onMouseEnter={() => setHoveredCompany(company.value)}
              onMouseLeave={() => setHoveredCompany(-1)}
              onClick={() => {
                changeCurrentCompany({ value: company.value })
                closeModal()
              }}
            >
              <div
                className="d-flex align-items-center p-2"
                style={{ borderRadius: "5px" }}
              >
                <ImageLoader
                  style={{ width: "50px", marginRight: "15px" }}
                  imgUrl={company.pathLogo}
                  resourceType="company"
                  whosCalling="Topbar 226"
                  alt={company.label.substring(0, 5)}
                />
                <div>
                  <strong
                    style={{
                      fontSize: 16,
                      lineHeight: "5px",
                    }}
                  >
                    {company.label}
                  </strong>
                  {checkDocument(company.document) !== "invalid" && (
                    <div
                      style={{
                        fontSize: 13,
                        opacity: 0.8,
                        lineHeight: "10px",
                      }}
                    >
                      <strong className="mr-1" style={{}}>
                        {checkDocument(company.document).toUpperCase()}:
                      </strong>
                      {company.document}
                    </div>
                  )}
                  <div className="mt-1">
                    {company.ChannelIds &&
                      company.ChannelIds.split(",").map((channelId) => {
                        const thisChannel = channels.find(
                          (channel) => channel.id === Number(channelId)
                        )

                        if (!thisChannel) return <div></div>

                        return (
                          <Tooltip
                            key={channelId}
                            arrow
                            title={thisChannel.description}
                          >
                            <ImageLoader
                              style={{
                                height: 25,
                                marginRight: 10,
                              }}
                              imgUrl={thisChannel.image}
                              resourceType="channel"
                              whosCalling="Topbar 226"
                            />
                          </Tooltip>
                        )
                      })}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </ModalContainer>
    </>
  )
}

export default ModalChangeCurrentCompany
